import React from 'react';
import { FiCheck } from 'react-icons/fi';

export function StepIndicator({ currentStep, totalSteps }) {
  return (
    <div className="flex items-center justify-between w-full max-w-3xl mb-8">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center ${
                index < currentStep
                  ? 'bg-blue-600 text-white'
                  : index === currentStep
                  ? 'bg-blue-100 text-blue-600 border-2 border-blue-600'
                  : 'bg-gray-100 text-gray-400'
              }`}
            >
              {index < currentStep ? (
                <FiCheck className="w-5 h-5" />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span
              className={`text-sm mt-2 ${
                index <= currentStep ? 'text-blue-600' : 'text-gray-400'
              }`}
            >
              {
                [
                  'Business Info',
                  'Channels',
                  'Payment Methods',
                  'More Integration',
                  'Review',
                ][index]
              }
            </span>
          </div>
          {index < totalSteps - 1 && (
            <div
              className={`flex-1 h-0.5 ${
                index < currentStep ? 'bg-blue-600' : 'bg-gray-200'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}